import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ChartData, GroupedBarChartComponent } from '../../../../_shared';
import { DateFilterComponent } from '../../../../../_shared/components';
import { DateIntervalFilterData } from '../../../../../_shared/models';
import { DateInterval } from '../../../../../_shared/enums';
import { TranslocoDirective } from '@jsverse/transloco';

@Component({
  selector: 'app-reconciliation-multiple-barchart',
  standalone: true,
  imports: [GroupedBarChartComponent, DateFilterComponent, TranslocoDirective],   // BigDoubleBarchart
  templateUrl: './reconciliation-multiple-barchart.component.html',
  styleUrl: './reconciliation-multiple-barchart.component.scss'
})
export class ReconciliationMultipleBarchart {
  protected reconciliationVariateBigData = ChartData.reconciliationVariateBig;
  protected buttonMenuClick(event: MouseEvent): void {
    event.stopPropagation();
  }

  public utilizationDateFilter: DateIntervalFilterData;
  public defaultInterval: DateInterval = DateInterval.Day;

  constructor(private modalRef: NgbActiveModal) {
    this.utilizationDateFilter = {} as DateIntervalFilterData;
  }

  onUtilizationDateFilterChange(filter: DateIntervalFilterData): void {
    this.utilizationDateFilter = filter;
  }

  protected closeModal(): void {
    this.modalRef.close();
  }
}
